(ns frontend.view.components.timeline.entry.comment-create
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.db :as db]
            [common.localization :as loc]
            [clojure.string :as string]
            [frontend.state.current-session :as session]))

(defn comment-text [text]
  (if (string/blank? text)
    "None"
    (->> text
         (take db/timeline-comment-length)
         (string/join ""))))

(defn title-generator [entry]
  (let [comment-text (->> entry
                          :audit/target
                          (get @session/entities)
                          :comment/text
                          comment-text
                          vector
                          (loc/tr :comment-title))
                {:keys [change-text!]} entry]
    [:span
     comment-text
     [:i.fal.fa-pencil.edit-icon
      {:on-click (fn [e]
                   (.preventDefault e)
                   (.stopPropagation e)
                   (change-text!))}]]))


(defmethod te/timeline-entry-view :op.comment/create [{entry :entry}]
  [default/timeline-item-view entry title-generator default/body-generator])
